import { createStyles, Text, ScrollArea, Group, Button, Flex } from "@mantine/core";
import { useNavigate } from "react-router";
import t from "../../stores/language";

import { useStore } from "../../stores/store";
import { supportedModules } from "../../stores/constants";
import insuranceImage from "../../assets/img/insurance.svg";
import InsuranceViewButton from "./insurance/insurance-upload";

const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
  },

  title: {
    fontWeight: theme.other.card.fontWeight,
    fontSize: theme.fontSizes.xl,
    color: theme.other.arc.colors[0],
  },

  item: {
    boxShadow: theme.other.arc.shadows.md,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${theme.colors.gray[3]}`,
    height: theme.other.card.height,
    width: theme.other.card.width,
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
    transition: "box-shadow 150ms ease, transform 100ms ease",
    "&:hover": {
      boxShadow: theme.other.arc.shadows.xl,
      transform: "scale(1.05)",
    },
  },
  ScrollArea: {
    height: "calc(100vh - 143px)",
  },
  cardContainer: {
    justifyContent: "left",
    gap: theme.spacing.xl,
    padding: theme.other.arc.paddings[3],
  },
}));

export const CardComponent = () => {
  const { classes } = useStyles();
  const navigateTo = useNavigate();
  const { store } = useStore();
  const items = supportedModules.map((item) => (
    <Flex key={item.title} className={classes.item}>
      <img src={item.img} alt={item.title} width={128} height={128} />
      <Text className={classes.title}>{item.title}</Text>
      <Button
        onClick={() => {
          const modules = store.modules;
          let id = 0;
          const parent = store.modules.find((d) => d.name === item.title);
          if (parent != null) {
            const module = modules.find((d) => d.parentId === parent.id);
            if (module != null) {
              id = module.id;
            }
          }
          if (id !== 0) {
            navigateTo(`/view/${item.title}/${id}`);
          }
        }}
      >
        {t("View")}
      </Button>
    </Flex>
  ));

  return (
    <div className={classes.card}>
      <ScrollArea className={classes.ScrollArea} scrollHideDelay={10}>
        <Group className={classes.cardContainer}>
          {items}
          <Flex className={classes.item}>
            <img src={insuranceImage} alt="Insurance" width={128} height={128} />
            <Text className={classes.title}>Insurance</Text>
            <InsuranceViewButton />
          </Flex>
        </Group>
      </ScrollArea>
    </div>
  );
};
